import React from 'react';
import { Search } from 'lucide-react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  fullWidth?: boolean;
}
export function Input({
  label,
  error,
  icon,
  fullWidth = true,
  className = '',
  ...props
}: InputProps) {
  return <div className={`${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-152">
      {label && <label className="block text-sm font-medium text-text-secondary mb-1.5" data-id="element-153">
          {label}
        </label>}
      <div className="relative" data-id="element-154">
        {icon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-text-muted" data-id="element-155">
            {icon}
          </div>}
        <input className={`
            block w-full rounded-lg border border-slate-700 bg-slate-800/50 
            text-text-primary placeholder-text-muted
            focus:border-primary focus:ring-1 focus:ring-primary focus:outline-none
            disabled:opacity-50 disabled:cursor-not-allowed
            transition-colors duration-200
            py-2.5
            ${icon ? 'pl-10' : 'pl-3'}
            ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''}
          `} {...props} data-id="element-156" />
      </div>
      {error && <p className="mt-1 text-xs text-red-500" data-id="element-157">{error}</p>}
    </div>;
}